import React, {useState} from 'react';
import {Header, RequestList} from "../../components";
import {connect} from "react-redux";
import {withRouter} from "../../../../utils/services/with-router";
import {Button, Flex, Tabs} from "antd";
import {StyledButton} from "./BorrowRequestList.styled";

const BorrowRequestList = () => {
    const [filterType, setFilterType] = useState<string>("")
    return (
    <Flex vertical justify={"center"} gap={"large"}>
        <Header  title={'درخواست ها'}/>
        <RequestList/>
    </Flex>
    );
};

export default connect(null, {})(
    withRouter(BorrowRequestList)
);
